import { CurrencyISO } from '@guiker/money'

import { CommonPurchaseCost } from '../purchase-cost'

export const CanadaPurchaseCost = {
  ...CommonPurchaseCost(CurrencyISO.CAD),
} as const
